import { Component } from '@angular/core';
import { ModalController, Platform, NavParams, ViewController,NavController } from 'ionic-angular';
import { ProjectDataProvider } from '../../providers/project-data-provider';
/*
  Generated class for the Project page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-project',
  templateUrl: 'project.html',
  providers : [ ProjectDataProvider ]
})
export class ProjectPage {
  project;
  update = false;

   constructor(
    public platform: Platform,
    public params: NavParams,
    public viewCtrl: ViewController,
    public prjDataProv : ProjectDataProvider
  ) {
    var obj = this.params.get("projectObj");
    console.log(obj);
    this.project = obj;
    if (this.project.projectNumber && this.project.projectNumber.trim() != '') {
      this.update = true;
    }
    
  }

  
  logForm() {
    // console.log(this.project)
    if(this.update){
      this.prjDataProv.updateProject(this.project);
    }
    else {
      this.prjDataProv.addProject(this.project);
    }
    
    this.dismiss();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

/*
  ionViewDidLoad() {
    console.log('ionViewDidLoad ProjectPage');
  }
*/
}



// WEBPACK FOOTER //
// ./src/pages/project/project.ts